import { useEffect, useReducer, useRef, useState } from "react"
import CenteredHero from "@/components/CenteredHero.jsx"
import Input from "@/components/input/Input.jsx"
import GeneralLayout from "@/layouts/General.jsx"
import { useForm } from "react-hook-form"
import clsx from "clsx"
import Select from "@/components/Select.jsx"
import dsdsLogo200 from "@/assets/imgs/rachman-sons-logo-gold-200h.webp"
import dsdsLogo400 from "@/assets/imgs/rachman-sons-logo-gold-400h.webp"
import RestaurantAPI from "@/app/api/di-sini/restaurant"
import { getError, handleError } from "@/app/utils/helpers.js"
import Barcode from "../components/barcode"
import { useGlobalContext } from "@/global/GlobalContext.jsx"
import { resSchema } from "@/app/utils/validation.js"
import "@/assets/css/button.css"
import { LoadButton } from "@/components/Button.jsx"
import ProcessModal from "@/components/ProcessModal.jsx"
import { useLocation } from "react-router-dom"
const restaurantApi = new RestaurantAPI()

const Reservation = () => {
  const { notifyError } = useGlobalContext()
  const { register, handleSubmit, setValue, reset } = useForm()
  const [dateOption, setDateOption] = useState([])
  const [monthOption, setMonthOption] = useState([])
  const [yearOption, setYearOption] = useState([])
  const [modalContent, setModalContent] = useState(null)
  const now = new Date()
  const currYear = now.getFullYear()
  const currMonth = now.getMonth()
  const [onSaving, setOnSaving] = useState(false)
  const { hash } = useLocation()
  const reservationFormRef = useRef(null)
  const defaultErr = {
    name: "",
    pax: "",
    email: "",
    phone_no: "",
    date: "",
    time: "",
    year: "",
    message: "",
  }
  const [errors, setErrors] = useState(defaultErr)

  useEffect(() => {
    setDateOption(getDatesInMonth(currYear, currMonth))
    setMonthOption(getMonthsInYear())
    setYearOption(getYears(currYear))

    setValue("pax", "1")
  }, [])

  useEffect(() => {
    if (hash) {
      if (hash == "#reservationForm") {
        const timer = setTimeout(() => {
          if (reservationFormRef.current) {
            reservationFormRef.current.scrollIntoView({
              behavior: "smooth",
            });
          }
        }, 500);

        return () => clearTimeout(timer);
      }
    }
  }, [hash])

  useEffect(() => {
    if (dateOption.length > 0) setValue("date", now.getDate())
  }, [dateOption])

  useEffect(() => {
    if (monthOption.length > 0) setValue("month", currMonth + 1)
  }, [monthOption])

  useEffect(() => {
    if (yearOption.length > 0) setValue("year", currYear)
  }, [yearOption])

  const getDatesInMonth = (year, month) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    return Array.from({ length: daysInMonth }, (_, i) => i + 1)
  }

  const getMonthsInYear = () => {
    const months = Array.from({ length: 12 }, (_, i) => i + 1)
    return months
  }

  const getYears = (year) => {
    const years = Array.from({ length: 10 }, (_, i) => year + i)
    return years
  }

  const onInputMonth = (val) => {
    setDateOption(getDatesInMonth(currYear, parseInt(val) - 1))
  }

  const onInputYear = (val) => {
    setDateOption(getDatesInMonth(parseInt(val) - 1, currMonth))
  }

  const onSubmit = async (formData) => {
    setOnSaving(true)
    const err = await createReservation(formData)

    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        setErrors({ ...newErrs })
      }
    }
    setOnSaving(false)
  }

  const getResDate = (date, month, year, time) => {
    const formattedDate = [year, month, date].join("-")
    const formattedTime = `${time}:00`

    return `${formattedDate} ${formattedTime}`
  }

  // API request
  const createReservation = async (formData) => {
    try {
      const insertedData = resSchema.safeParse({
        name: formData.name,
        pax: parseInt(formData.pax),
        phone: formData.phone,
        email: formData.email,
        date: formData.date.toString(),
        month: formData.month.toString(),
        year: formData.year.toString(),
        time: formData.time,
        message: formData.message,
      })

      const resDate = getResDate(formData.date, formData.month, formData.year, formData.time)
      if (!insertedData.success) return { error: insertedData.error.issues }
      const inserted = {
        name: insertedData.data.name,
        pax: insertedData.data.pax,
        phone: insertedData.data.phone,
        email: insertedData.data.email,
        reservation_date: resDate,
        message: insertedData.data.message,
      }

      const { data } = await restaurantApi.createReservation(inserted)
      if (data.code == 200) {
        setModalContent({ msg: "Your reservation has been successfully made! Wait for further confirmation from us.", isOpen: true })
        reset()
        setValue("date", now.getDate())
        setValue("month", currMonth + 1)
        setValue("year", currYear)
        setErrors(defaultErr)
      }
    } catch (err) {
      if (err.status == 500) return notifyError("Internal server error, please try again later.")
      return getError(err)
    }
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} />
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <CenteredHero custCls="bg-[url('/src/assets/imgs/di-sini/reservation/banner.jpg')] bg-bottom md:min-h-60 lg:min-h-96" title={"Reservation"} />
        <section ref={reservationFormRef} className="bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] p-5 md:p-12 lg:p-20">
          <div className="bg-gray-200 bg-opacity-50 grid grid-rows-[8fr_1fr] md:grid-cols-[2fr_3fr] md:grid-rows-none overflow-hidden" style={{ boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)" }}>
            <div className="bg-[url('/src/assets/imgs/di-sini/reservation/two-waitress.jpg')] bg-cover bg-center order-last md:order-none" style={{ boxShadow: "2px 0px 15px rgba(0, 0, 0, 0.5)", height: "100%" }}></div>
            <div className="relative p-5 md:p-8 lg:p-10">
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className={clsx("font-light text-[#6d625a] font-agcasmlt text-xl md:text-2xl")}>Reservation</h2>
                  <img
                    src={dsdsLogo200}
                    srcSet={`${dsdsLogo200} 158w, ${dsdsLogo400} 316w`}
                    sizes="(max-width: 768px) 48px, (max-width: 1024px) 64px, 96px"
                    width="158"
                    height="200"
                    loading="lazy"
                    decoding="async"
                    alt=""
                    className="w-12 md:w-16 lg:w-24"
                  />
                </div>
                <h1 className={clsx("font-light font-sloopScriptPro text-3xl md:text-5xl lg:text-7xl tracking-wide mb-10 text-[rgb(149,112,46)]")}>Book Your Table</h1>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="">
                      <Input type="text" required custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" label="Name :" isInput1 placeholder="Name" name="name" id="name" custCls={errors.name ? "border-red-600" : ""} errMsg={errors.name} ref={{ ...register("name") }} />
                    </div>
                    <div className="w-3/4">
                      <Input type="number" required defaultVal="1" custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" label="Pax :" isInput1 placeholder="Pax" name="pax" id="pax" custCls={errors.name ? "border-red-600" : ""} errMsg={errors.pax} ref={{ ...register("pax") }} />
                    </div>
                    <div className="">
                      <Input type="email" required custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" label="Email :" isInput1 placeholder="Email" name="email" id="email" custCls={errors.email ? "border-red-600" : ""} errMsg={errors.email} ref={{ ...register("email") }} />
                    </div>
                    <div className="w-3/4">
                      <Input type="text" required custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" label="Phone No :" isInput1 placeholder="Phone Number" name="phone_no" id="phone-no" custCls={errors.email ? "border-red-600" : ""} errMsg={errors.phone} ref={{ ...register("phone") }} />
                    </div>
                    <div className="">
                      <label className={clsx("font-agcasmlt font-light text-[#6d625a] inline-block text-lg sm:text-xl lg:text-2xl mb-1")}>Date :</label>
                      <div className="grid grid-cols-3 gap-4 mt-0">
                        <div>
                          <Select required noLabel options={dateOption} errMsg={errors.date} ref={{ ...register("date") }} />
                        </div>
                        <div>
                          <Select required noLabel options={monthOption} onInputSelect={onInputMonth} errMsg={errors.month} ref={{ ...register("month") }} />
                        </div>
                        <div>
                          <Select required noLabel options={yearOption} onInputSelect={onInputYear} errMsg={errors.year} ref={{ ...register("year") }} />
                          {/* <Select required noLabel options={yearOption} onInputSelect={onInputYear} errMsg={errors.year} ref={{ ...register("year") }} /> */}
                        </div>
                      </div>
                    </div>
                    <div className="w-1/2">
                      <Input type="time" required custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" label="Time :" isInput1 name="time" id="time" custCls={errors.time ? "border-red-600" : ""} errMsg={errors.time} ref={{ ...register("time") }} />
                      {/* <Select titleOption="" label="Time:" custLabelCls="text-lg sm:text-xl lg:text-2xl mb-1" errMsg={errors.time} ref={{ ...register("time") }} /> */}
                    </div>
                    <div className="flex col-span-2 gap-4">
                      <div className="w-2/3 md:w-3/4 lg:w-4/5">
                        <div>
                          <label className="font-agcasmlt font-light text-[#6d625a] inline-block text-lg sm:text-xl lg:text-2xl mb-1">Message:</label>
                          <textarea required rows="5" placeholder="Message" {...register("message")} className="border-[1.5px] border-[#6d625a] font-agcasmlt font-light text-base placeholder-[#9f978e] pt-2 px-2 focus:outline-none w-full bg-transparent"></textarea>
                          {errors.message && (
                            <span className="text-[10px] sm:text-[12px] text-red-600">{errors.message}</span>
                          )}
                        </div>
                        <LoadButton type="submit" isLoading={onSaving} text="Reserve Now" />
                      </div>
                      <div className="w-1/3 md:w-1/4">
                        <Barcode />
                        <p className="font-agcasmlt font-light text-[14px] md:text-[16px] leading-[20px] text-[#6d625a] text-center my-4">If you have any questions, <br /> please scan to contact us.</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default Reservation
